import React from 'react';
import { translations } from '../translations';

// Export context
export const LanguageContext = React.createContext(translations.en);
